
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing-city-seller",
      function () {
        return require("private-next-pages/landing-city-seller.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing-city-seller"])
      });
    }
  